<template>
    <div class="wrapper">
        <div
            class="member-num-box flex align-center justify-between margin-bottom-sm"
        >
            <router-link class="member-num" :to="power('3-0') ? '/branch/members/list' : ''">
                <b>{{ passNum }}</b>
                <p>会员数量/人</p>
            </router-link>
            <router-link class="member-num" :to="power('3-0') ? '/branch/members/exam' : ''">
                <b>{{ examNum }}</b>
                <p>待审核会员/人</p>
            </router-link>
            <router-link class="member-num" :to="power('3-0') ? '/branch/members/list?fee=2' : ''">
                <b>{{ expireNum }}</b>
                <p>待续费会员/人</p>
            </router-link>
        </div>
        <div class="menu-box flex align-center flex-wrap margin-bottom-sm">
            <router-link v-if="power('1-0')" class="menu-item" to="/branch/notice/list">会员通知</router-link>
            <router-link v-if="power('1-1')" class="menu-item" to="/branch/message/list">短信群发</router-link>
            <router-link v-if="power('5-1')" class="menu-item" to="/branch/organ/dynamic">机构动态</router-link>
            <router-link v-if="power('5-2')" class="menu-item" to="/branch/organ/activity">活动管理</router-link>
            <router-link v-if="power('5-3')" class="menu-item" to="/branch/organ/server">服务管理</router-link>
            <router-link v-if="power('6-2')" class="menu-item" to="/branch/server/opinion">意见建议</router-link>
<!--            <router-link v-if="power('2-0')" class="menu-item" to="/branch/setup/level">级别管理</router-link>-->
            <router-link v-if="power('3-0')" class="menu-item" to="/branch/members/list">会员列表</router-link>
            <router-link v-if="power('3-2')" class="menu-item" to="/branch/setup/invitation">会员邀请</router-link>
            <router-link v-if="power('2-4')" class="menu-item" to="/branch/setup/explain">会员说明</router-link>
        </div>
        <div class="flex align-center justify-between margin-bottom-sm">
            <div class="statistics-box flex-sub margin-right-xs">
                <div class="flex align-center statistics-title">
          <span
              :class="{ active: statisticsType === 1 }"
              @click="statisticsType = 1"
          >单位会员统计</span
          >
                    <span
                        :class="{ active: statisticsType === 2 }"
                        @click="statisticsType = 2"
                    >单位会员地区统计</span
                    >
                    <span
                        :class="{ active: statisticsType === 3 }"
                        @click="statisticsType = 3"
                    >个人会员统计</span
                    >
                    <span
                        :class="{ active: statisticsType === 4 }"
                        @click="statisticsType = 4"
                    >个人会员地区统计</span
                    >
                </div>
                <div>
                    <pie-statistics-modular
                        :id="'member'"
                        :data="statisticsType === 1 ? memberData: ( statisticsType === 2 ? addressData : (statisticsType === 3 ? memberPersonalData : addressPersonalData))"
                        :title="'会员人数统计'"
                    />
                </div>

            </div>
            <div class="statistics-box flex-sub margin-left-xs">
                <div class="flex align-center statistics-title">
                    <span class="active">会员等级统计</span>
                </div>
                <pie-statistics-modular
                    :id="'level'"
                    :data="levelData"
                    :title="'会员等级统计'"
                />
            </div>
        </div>
        <div class="statistics-box margin-bottom-sm">
            <div class="flex align-center statistics-title">
                <span
                    :class="{ active: increaseType === 1 }"
                    @click="increaseType = 1"
                >单位会员续费统计</span
                >
                <span
                    :class="{ active: increaseType === 2 }"
                    @click="increaseType = 2"
                >个人会员续费统计</span
                >
            </div>
            <bp-statistics-modular
                :id="'pay'"
                :increase="increaseType === 1? increaseData : increasePersonalData"
                :month="increaseType === 1? month : monthPersonal"
                :outData="increaseType === 1 ? outData : outPersonalData"
                :reduce="increaseType === 1 ? reduceData : reducePersonalData"
                :title="'会员续费统计'"
                :total="increaseType === 1 ? totalData : totalPersonalData"
            />
        </div>
        <div class="statistics-box margin-bottom-sm" v-if="orgData.length > 0">
            <div class="flex align-center statistics-title">
                <span class="active">机构数据</span>
            </div>
            <line-statistics-modular
                :id="'org'"
                :month="monthDate"
                :title="'机构数据'"
                :total="orgData"
            />
        </div>

        <div class="member-num-box flex flex-wrap align-center">
            <div class="total margin-bottom-sm" v-for="(item,index) in customTotals" :key="index">
                <p>{{ item.title }}：</p>
                <b>{{ item.number }}</b>
            </div>
        </div>
    </div>
</template>

<script>
import PieStatisticsModular from '@/components/PieStatisticsModular'
import BpStatisticsModular from '@/components/BpStatisticsModular.vue'
import LineStatisticsModular from '@/components/LineStatisticsModular.vue'
import {
    getFhPower,
    getUserGradeStatistics,
    getUserNumberStatistics,
    getUserNumberStatisticsByRegion,
    getUserNumberStatisticsByRegionPersonal,
    getUserNumberStatisticsPersonal,
    jiGouShuJu,
    tongJiUserNumber,
    userRenewStatistics,
    userRenewStatisticsPersonal,
    customFieldStatistics,
} from "@/api/branch";
import {isPower} from "@/utils/utils";

export default {
    name: "index",
    data() {
        return {
            passNum: 0,
            examNum: 0,
            expireNum: 0,

            powers: [],
            statisticsType: 1,
            memberData: [],
            memberPersonalData: [],
            addressData: [],
            addressPersonalData: [],
            levelData: [],
            month: [],
            monthPersonal: [],
            increaseType: 1,
            increasePersonalData: [],
            increaseData: [],
            reduceData: [],
            reducePersonalData: [],
            outData: [],
            outPersonalData: [],
            totalData: [],
            totalPersonalData: [],

            monthDate: [],
            orgData: [],

            customTotals: [],
        }
    },
    created() {
        this.$emit('setIndex', [0], '首页')
        this.init()
        this.tongJiUserNumber()
        this.getUserNumberStatistics()
        this.getUserNumberStatisticsPersonal()
        this.getUserNumberStatisticsByRegion()
        this.getUserNumberStatisticsByRegionPersonal()
        this.getUserGradeStatistics()
        this.userRenewStatistics()
        this.userRenewStatisticsPersonal()
        this.jiGouShuJu()
        this.customFieldStatistics()
    },
    computed: {
        user() {
            return this.$store.state.user
        }
    },
    components: {
        PieStatisticsModular,
        BpStatisticsModular,
        LineStatisticsModular
    },
    methods: {
        async customFieldStatistics() {
            let _data = await customFieldStatistics()
            this.customTotals= _data.data
        },
        //  页面加载时请求
        async init() {
            let _data = await getFhPower(this.user.fhid)
            if (_data.data) {
                this.powers = _data.data.split(',')
            }
        },
        power(type) {
            return isPower(this.powers,type)
        },
        async tongJiUserNumber() {
            let _data = await tongJiUserNumber()
            this.passNum = _data.data.usersCountAll
            this.examNum = _data.data.usersCheckAll
            this.expireNum = _data.data.usersRenewAll
        },
        async getUserNumberStatistics() {
            let _data = await getUserNumberStatistics()
            _data.data.map(item => {
                this.memberData.push({
                    name: item.name + (item.proportion * 100).toFixed(2) + '%',
                    value: item.num
                })
            })

        },
        async getUserNumberStatisticsPersonal() {
            let _data = await getUserNumberStatisticsPersonal()
            _data.data.map(item => {
                this.memberPersonalData.push({
                    name: item.name + (item.proportion * 100).toFixed(2) + '%',
                    value: item.num
                })
            })

        },
        async getUserNumberStatisticsByRegion() {
            let _data = await getUserNumberStatisticsByRegion()
            _data.data.map(item => {
                this.addressData.push({
                    name: item.name + (item.proportion * 100).toFixed(2) + '%',
                    value: item.num
                })
            })

        },
        async getUserNumberStatisticsByRegionPersonal() {
            let _data = await getUserNumberStatisticsByRegionPersonal()
            _data.data.map(item => {
                this.addressPersonalData.push({
                    name: item.name + (item.proportion * 100).toFixed(2) + '%',
                    value: item.num
                })
            })

        },


        async getUserGradeStatistics() {
            let _data = await getUserGradeStatistics()
            _data.data.map(item => {
                this.levelData.push({
                    name: item.name + (item.proportion * 100).toFixed(2) + '%',
                    value: item.number
                })
            })
        },
        async userRenewStatistics() {
            let _data = await userRenewStatistics()
            _data.data.huiYuanShuLiangData.map(item => {
                this.month.push(item.monthdata)
            })
            this.increaseData = this.zhValue2(_data.data.daoQiData)
            this.reduceData = this.zhValue2(_data.data.xuFeiData)
            this.outData = this.zhValue2(_data.data.tuiHuiData)
            this.totalData = this.zhValue2(_data.data.huiYuanShuLiangData)


        },
        async userRenewStatisticsPersonal() {
            let _data = await userRenewStatisticsPersonal()
            _data.data.huiYuanShuLiangData.map(item => {
                this.monthPersonal.push(item.monthdata)
            })
            this.increasePersonalData = this.zhValue2(_data.data.daoQiData)
            this.reducePersonalData = this.zhValue2(_data.data.xuFeiData)
            this.outPersonalData = this.zhValue2(_data.data.tuiHuiData)
            this.totalPersonalData = this.zhValue2(_data.data.huiYuanShuLiangData)


        },
        async jiGouShuJu() {
            let _data = await jiGouShuJu()
            let _arr1 = this.zhValue(_data.data.tongZhiGongGao)
            let _arr2 = this.zhValue(_data.data.jiGouDongTai)
            // let _arr3 = this.zhValue(_data.data.huoDongGuanLi)
            let _arr4 = this.zhValue(_data.data.fuWuShenQing)
            _data.data.jiGouDongTai.map(item => {
                this.monthDate.push(item.date)
            })
            if (this.power('1-0')){
                this.orgData.push({name: '通知公告', type: 'line', data: _arr1})
            }
            if (this.power('5-1')){
                this.orgData.push({name: '机构动态', type: 'line', data: _arr2})
            }
            if (this.power('5-3')){
                this.orgData.push({name: '服务申请', type: 'line', data: _arr4})
            }
        },

        zhValue(arr) {
            let _arr = []
            arr.map(item => {
                _arr.push(item.number)
            })
            return _arr
        },
        zhValue2(arr) {
            let _arr = []
            arr.map(item => {
                _arr.push(item.num)
            })
            return _arr
        }

    },
    filters: {

    },

}
</script>

<style lang="scss" scoped>
.wrapper {
    .member-num-box {
        .total{
            &:not(:nth-child(4n+1)){
                margin-left: 20px;
            }
            width: 230px;
            height: 100px;
            border-radius: 10px;
            padding: 10px;
            border: solid 1px rgba($color: #fff, $alpha: 0.5);
            background: rgba($color: #fff, $alpha: 0.3);
            position: relative;
            b {
                position: absolute;
                display: block;
                text-align: center;
                font-size: 36px;
                color: #ff9600;
                right: 10px;
                bottom: 10px;
            }

            p {
                font-size: 18px;
                line-height: 22px;
                color: #ffffff;
            }
        }
        .member-num {
            display: block;
            width: 312px;
            height: 100px;
            border-radius: 10px;
            padding: 10px 0;
            border: solid 1px rgba($color: #fff, $alpha: 0.5);
            background: rgba($color: #fff, $alpha: 0.3);

            &:hover {
                background-image: linear-gradient(37deg, #ffb400 0%, #fc7802 100%),
                linear-gradient(#ffffff, #ffffff);
                background-blend-mode: normal, normal;

                b {
                    color: #fff;
                }
            }

            b {
                display: block;
                text-align: center;
                font-size: 40px;
                line-height: 48px;
                color: #ff9600;
            }

            p {
                font-size: 18px;
                line-height: 34px;
                color: #ffffff;
                text-align: center;
            }
        }
    }

    .menu-box {
        padding: 20px 20px 0;
        background: rgba($color: #fff, $alpha: 0.2);
        border-radius: 10px;

        .menu-item {
            display: block;
            width: 139px;
            height: 70px;
            text-align: center;
            line-height: 68px;
            font-size: 18px;
            color: #fff;
            border-radius: 10px;
            margin: 0 20px 20px 0;
            border: solid 1px rgba($color: #fff, $alpha: 0.5);
            background: rgba($color: #fff, $alpha: 0.2);

            &:hover {
                background-image: linear-gradient(37deg, #ffb400 0%, #fc7802 100%);
            }

            &:nth-child(6n) {
                margin-right: 0;
            }
        }
    }

    .statistics-box {
        padding: 20px;
        background: #fff;
        border-radius: 10px;

        .statistics-title {
            width: max-content;
            height: 32px;
            background-color: rgba($color: #0a2240, $alpha: 0.2);
            border-radius: 10px;

            span {
                display: block;
                height: 32px;
                line-height: 32px;
                padding: 0 6px;
                border-radius: 10px;
                color: #7b8ea8;
                cursor: pointer;
                font-weight: 500;

                &.active {
                    background-color: #ff9600;
                    border-radius: 10px;
                    color: #fff;
                }
            }
        }
    }
}
</style>
